var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-icon"},[_c('figure',{class:("image is-" + _vm.size + "x" + _vm.size + " user-image")},[_c('img',{staticClass:"round is-unselectable",attrs:{"draggable":"false","src":_vm.user.displayAvatarURL}})])])}
var staticRenderFns = []

export { render, staticRenderFns }